import { Component, OnInit, ViewChild, Input, Output } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { ProductDownloadReq } from 'src/app/model/product-download-req';
import { ProductDto } from 'src/app/model/ProductDto';
import { ProductRelease } from 'src/app/model/ProductRelease';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'ms-product-releases-table',
  templateUrl: './product-releases-table.component.html',
  styleUrls: ['./product-releases-table.component.scss']
})
export class ProductReleasesTable implements OnInit  {
  constructor(
    private router: Router,
    private navigateService: NavigateService,
    private productDownloadService: ProductDownloadService,
    private variable: TranslatedVariables,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
      return false;
    };
  }

  @Input() family!: string;
  @Input() productCode!: string;
  @Input() isPlatinumPartner: boolean = false;
  @Output() openedRelease = new EventEmitter();

  productReleasesTable: MatTableDataSource<ProductRelease> = new MatTableDataSource<ProductRelease>();
  displayedColumns: string[] = ['version', 'type', 'pubblicationDate', 'fileName', 'size'];
  isLoading: boolean = false;
  downloadLoading: boolean = false;

  _userspaginator: MatPaginator;
  @ViewChild('releasespaginator') set paginator(contentOrders: MatPaginator) {
      if (contentOrders) {
          this._userspaginator = contentOrders;
          const paginatorIntl = this._userspaginator._intl;
          paginatorIntl.nextPageLabel = this.variable.nextPage;
          paginatorIntl.previousPageLabel = this.variable.previousPage;
          if (this.productReleasesTable) {
              this.productReleasesTable.paginator = this._userspaginator;
          }
      }
  }

  ngOnInit(): void {
    this.isLoading = true;
    if(this.productCode == 'MAGOCLD')
      this.displayedColumns = ['version', 'type', 'pubblicationDate']
    this.productDownloadService.getProductReleases(this.family, this.productCode ?? this.family)
    .then((res) => {
      if(res.Result && res.Content)
        this.productReleasesTable.data = res.Content
      this.isLoading = false
    })
    .catch(err => {
      this.isLoading = false
    })
  }

  getProductDescription(){
    return this.productReleasesTable.data[0].Description ?? ''
  }

  getDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString()
  }

  noReleases(): boolean{
    return this.productReleasesTable.data.length < 1
  }

  public openRelease(productRelease: ProductRelease){
    let productDto = new ProductDto(this.family, productRelease.ProductCode, productRelease.ReleaseNr);
    this.navigateService.setLocalStorageData('productDto', JSON.stringify(productDto))
    /*let url = '/products-download/product-viewer'
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([url]);
    });*/
    this.openedRelease.emit(JSON.stringify(productDto));
  }

  public getFileName(publishedFileName: string): string{
    let multipleNames = publishedFileName.split(';');
    if(multipleNames.length == 1)
      return publishedFileName;
    else
      return this.isPlatinumPartner ? multipleNames[1] : multipleNames[0]
  }
}
